module.exports = __webpack_public_path__ + "static/media/scenario-playing.4a85c06e.png";